import { createSlice } from '@reduxjs/toolkit';
import { clearState } from '../../rootAccess';

const initialState = {
   participants: {},
   loading: false,
   error: null,
};

const groupParticipantsSlice = createSlice({
   name: 'groupParticipantsData',
   initialState,
   reducers: {
      setGroupParticipants: (state, action) => {
         const { groupId, participants } = action.payload;
         state.participants[groupId] = participants;
      },
   },
   extraReducers: builder => {
      builder.addCase(clearState, () => {
         return initialState;
      });
   },
});

export const { setGroupParticipants } = groupParticipantsSlice.actions;

export const { reducer: groupParticipantsReducer } = groupParticipantsSlice;
